import PropTypes from 'prop-types';
import styles from './Tiles.module.scss';
import Tile from '../cards/Tile';

export default function Tiles({ tiles, fullScreen }) {
  const containerClassName = [
    styles.tiles__container,
    fullScreen ? styles['--full-screen'] : '',
  ]
    .join(' ')
    .trim();

  return (
    <section className={styles.tiles}>
      <div className={containerClassName}>
        {tiles.map((card, index) => (
          <Tile key={index} {...card} />
        ))}
      </div>
    </section>
  );
}

Tiles.defaultProps = {
  tiles: null,
  fullScreen: false,
};

Tiles.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  /**
   * Tile components to render in block
   */
  tiles: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.func,
      heading: PropTypes.string,
      content: PropTypes.string,
      buttonText: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  /**
   * Is the block fullscreen or is it rendered in another container?
   */
  fullScreen: PropTypes.bool,
};
